/**
 * Breakpoint JS constants for responsive design
 * Used across components for consistent breakpoint values
 */
export const BREAKPOINTS = {
	mobile: 0, // default, 0px and up
	small: 600, // small tablets
	medium: 861, // large tablets
	large: 1136, // desktop
	xlarge: 1920, // large desktop
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;
